// eslint-disable-next-line no-underscore-dangle
let _debounceTimeout;

/**
 * Call a given function after duration has passed with no
 * additional calls
 *
 * @param {Function} fn
 * @param {number} duration
 */
export default function debounce(fn, duration = 150) {
  if (_debounceTimeout) {
    clearTimeout(_debounceTimeout);
    _debounceTimeout = null;
  }

  _debounceTimeout = setTimeout(fn, duration);
}
